import { routes } from "@/constants/routes";
import { Redirect } from "expo-router";

/** Das Vereinsprofil unter der Mandanten-Konfiguration gibt es nicht mehr. */
export default function ConfigProfileRedirect() {
  return <Redirect href={routes.home} />;
}
